import { Button, Typography } from '@breetometer/components';
import { CopyIcon, InfoIcon } from 'BreetAssets';
import { ErrorPage, Loader } from 'BreetComponents';
import { copyToClipboard, handleApiError, viewHelpArticle } from 'BreetHelpers';
import { useInitiate2faAuthenticatorMutation } from 'BreetRedux';
import QRCode from 'qrcode';
import { useEffect, useRef, useState } from 'react';

import ImageComponent from '@/components/ImageComponent';

const AuthenticatorQr = ({ onNext, closeAllModal }: { onNext: () => void; closeAllModal: () => void }) => {
	const [initiate2faAuthenticator, { data: initiate2faAuthenticatorData, isLoading }] = useInitiate2faAuthenticatorMutation();

	const callOnce = useRef<boolean>(false);

	useEffect(() => {
		if (!callOnce.current) {
			callOnce.current = true;
			initiate2faAuthenticator().catch(handleApiError);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [qrImageUrl, setQrImageUrl] = useState<string>('');

	const generateQR = async (value: string) => {
		try {
			const url = await QRCode.toDataURL(value);
			setQrImageUrl(url);
		} catch (err) {
			console.error(err);
		}
	};

	useEffect(() => {
		if (initiate2faAuthenticatorData?.data?.provisioningUri) {
			generateQR(initiate2faAuthenticatorData.data.provisioningUri).catch(console.error);
		}
	}, [initiate2faAuthenticatorData?.data?.provisioningUri]);

	if (isLoading) {
		return <Loader bgClassName='bg-primary-500' />;
	}

	if (!initiate2faAuthenticatorData?.data) {
		return <ErrorPage cta={{ action: closeAllModal }} />;
	}

	return (
		<div className='authenticator-qr'>
			<div className='qr-container'>
				<ImageComponent
					src={qrImageUrl}
					alt='Authenticator QR'
				/>
			</div>

			<Typography className='qr-description color-tertiary-400'>
				Scan the above QR code with your authenticator app to get started.
			</Typography>

			<div className='qr-preference'>
				<span className='line bg-dark-navy' />
				<Typography className='color-primary-100'>OR</Typography>
				<span className='line bg-dark-navy' />
			</div>

			<div>
				<Typography className='qr-instruction color-tertiary-400'>Use Time-Based Setup Key</Typography>
				<Typography className='qr-instruction-sub color-primary-100'>Copy the setup key into your authenticator app.</Typography>
			</div>

			<div className='qr-copy border-dark-navy bg-primary-400'>
				<Typography className='color-neutral-50'>{initiate2faAuthenticatorData.data.secret}</Typography>

				<Button
					variant='native'
					className='bg-primary-500 color-tertiary-400 border-dark-navy'
					onClick={copyToClipboard(initiate2faAuthenticatorData.data.secret, 'Authenticator Secret copied')}
				>
					Copy{' '}
					<CopyIcon
						variant='dark'
						className='svg-dark'
					/>
				</Button>
			</div>

			<div className='qr-cta'>
				<div className='qr-learn-more'>
					<InfoIcon className='svg-dark' />
					<Typography
						as='a'
						onClick={viewHelpArticle('15544716')}
						className='color-tertiary-400'
					>
						Learn more.
					</Typography>
				</div>

				<div className='new-btn-cta'>
					<Button
						onClick={onNext}
						className='primary-hover'
					>
						Continue
					</Button>
				</div>
			</div>
		</div>
	);
};

export default AuthenticatorQr;
